export default {
  SET_ASSIGNED_CHATS(state, payload) {
    state.assignedChats = payload;
  },
  SET_TODAY(state, payload) {
    state.todayChats = payload;
  }
};
